import * as React from "react";

import {Button} from "../static/Elements";
import {withAlert} from "react-alert";
import Modal from "../static/Modal";
import Icon from "../static/Icons";
import EditTitle from "./EditTitle";
import { capitalizeJobTitle } from "../../utils/utils";

class JobTitleEntry extends React.Component {

  /*-------- lifecycle methods --------*/

  constructor(props) {
    super(props);
    this.state = {
      deleteModalIsOpen: false,
      editModalIsOpen: false,
    }
  }

  /*-------- event handlers --------*/

  deleteTitleClick = () => () => {
    const { removeTitle, title, _id, alert } = this.props;
    console.log(`Removing id ${_id}`);
    removeTitle(_id);
    this.closeDeleteModal();
    alert.error(<p className={`alert-message`}>Title '{title}' deleted</p>)
  };

  openDeleteModal = () => this.setState({deleteModalIsOpen: true});
  closeDeleteModal = () => this.setState({deleteModalIsOpen: false});

  openEditModal = () => this.setState({editModalIsOpen: true});
  closeEditModal = () => this.setState({editModalIsOpen: false});



  /*-------- render methods --------*/

  render () {

    const {
      title,
      category,
      exclude,
      _id,
      titles,
      categories,
    } = this.props;

    const {
      deleteModalIsOpen,
      editModalIsOpen,
    } = this.state;

    const {
      openDeleteModal,
      closeDeleteModal,
      openEditModal,
      closeEditModal,
      deleteTitleClick
    } = this;


    return (
        <div className={`job-title-entry`}>

          <Modal title="Are you sure you want to delete this title?"
               isOpen={deleteModalIsOpen}
               close={closeDeleteModal}>
            <div className={`job-title-entry margin-top`}>
              <div className={`job-title-info`}>
                <h5>{title}</h5>
                <p>{category}</p>
              </div>
            </div>
            <div className={`confirm-delete-modal-buttons`}>
              <Button action onClick={closeDeleteModal}>
                <Icon.Close/> Cancel
              </Button>
              <Button danger onClick={deleteTitleClick()}>
                <Icon.Remove/> Delete
              </Button>
            </div>
          </Modal>

          <Modal title="Edit Title"
               isOpen={editModalIsOpen}
               close={closeEditModal}>
            <EditTitle closeModal={closeEditModal}
                       categories={categories}
                       title={title}
                       titles={titles}
                       category={category}
                       exclude={exclude}
                       _id={_id}/>
          </Modal>

          <div className={`job-title-info`}>
            <h4>{capitalizeJobTitle(title)}</h4>
            <p>Category:</p>
            <h5>{category}</h5>
          </div>
          <div className={`job-title-actions`}>
            <Button small action
                    onClick = {openEditModal}>
              <Icon.Edit/>
            </Button>
            <hr/>
            <Button small action
                    danger
                    onClick = {openDeleteModal}>
              <Icon.Trash/>
            </Button>
          </div>
        </div>
    )
  }
}

export default withAlert(JobTitleEntry);


// WEBPACK FOOTER //
// ./src/components/Titles/JobTitleEntry.js